module.exports = __webpack_public_path__ + "static/media/Sharp-LS022B7DH03.ad5c2c39.png";